var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "945px",
    height: "945px",
    viewBox: "0 0 945 945",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(630.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2374193,8.77320139 C64.4473651,-2.46465646 33.7000037,-2.97387346 14.558264,7.6354823 C-4.59352391,18.2448381 -4.88492047,35.9541623 13.8950856,47.1920202 C32.6750916,58.4288756 63.0908639,58.9481166 82.5943372,48.5542759 C104.027057,37.1289701 102.017425,20.0100568 83.2374193,8.77320139",
    id: "Fill-397",
    fill: "#51DEA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7579932,14.5927289 L26.1970464,33.6198715 C25.7060799,35.3152803 26.1469478,37.1455626 27.3593344,38.4303567 C28.571721,39.71615 30.3752713,40.2666334 32.1086835,39.876999 L77.1072635,29.7225292 C79.8025693,29.1141003 81.4858829,26.4446056 80.8746797,23.759126 C80.2734963,21.0736464 77.5882103,19.3892273 74.9029243,19.9966572 L38.1706165,28.2838794 L41.3568887,17.3801129 C42.1284074,14.7365939 40.6054094,11.9691911 37.9501825,11.1999131 C35.3049754,10.4306351 32.5295119,11.9492099 31.7579932,14.5927289",
    id: "Fill-398",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.b0586dd1578ecf4c5fcf6976b937dc47.svg";
export { ForwardRef as ReactComponent };